module.exports = __webpack_public_path__ + "img/nas-download-icon1.66786f4e.png";